(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/vikinglotto/assets/javascripts/views/prolongation-page.js') >= 0) return;  svs.modules.push('/modules/vikinglotto/assets/javascripts/views/prolongation-page.js');

'use strict';

svs.vikinglotto.views.ProlongationPage = Marionette.View.extend({
  behaviors: [{
    behaviorClass: svs.numbergames.game_app.behaviors.LoadModuleComponent,
    module: 'vikinglotto',
    component: 'prolongation'
  }],
  regions: {
    prolongationRegion: '#ngProlongationRegion'
  },
  template() {
    return svs.vikinglotto.templates.prolongation_page();
  },
  onRender() {
    if (svs.vikinglotto.components.prolongation) {
      this.showChildView('prolongationRegion', new svs.vikinglotto.components.prolongation.views.Prolongation());
    }
  }
});

 })(window);